export const STORAGE_KEYS = {
  IS_CLEAN_PAUSE: "IS_CLEAN_PAUSE",
}
